/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import { MasterButtonNav } from "../MasterButtonNav";
import "./style.css";

export const Default = ({
  className,
  masterButtonNavText = "Label",
  masterButtonNavDivClassName,
  masterButtonNavHasIconButton,
}) => {
  return (
    <div className={`default ${className}`}>
      <MasterButtonNav
        className="design-component-instance-node"
        divClassName={masterButtonNavDivClassName}
        hasIconButton={masterButtonNavHasIconButton}
        iconButtonClassName="master-button-nav-instance"
        text={masterButtonNavText}
        visible={false}
      />
    </div>
  );
};

Default.propTypes = {
  masterButtonNavText: PropTypes.string,
  masterButtonNavHasIconButton: PropTypes.bool,
};
